import React, { useEffect, useState } from 'react';
import { List } from '@mui/material';
import { useSelector } from 'react-redux';
import NavGroup from './NavGroup';
import { iconMap } from '../../../utils/iconMapper';

/**
 * MenuList component
 * @returns {JSX.Element} MenuList component
 */
const MenuList = () => {
    /**
     * Get account data from redux store
     */
    const account = useSelector((state) => state.account);
    const [loaded, setLoaded] = useState(false);
    const [newMenuItems, setNewMenuItems] = useState([]);

    const convertIcons = (menus) =>
        /**
         * Convert icons to MUI icons
         * @param {Array} menus - Menu items
         * @returns {Array} - Menu items with converted icons
         */
        menus.map((m) => ({
            ...m,
            icon: iconMap[m.icon] || null,
            children: m.children ? convertIcons(m.children) : m.children
        }));

    useEffect(() => {
        /**
         * Convert icons to MUI icons
         */
        if (!loaded && account.authMenu) {
            setNewMenuItems(convertIcons(account.authMenu));
            setLoaded(true);
        }
    }, [account, loaded]);

    return (
        /**
         * Render menu items
         */
        <List disablePadding sx={{ p: 0, m: 0, pl: 0 }}>
            {newMenuItems.map((item) => (
                <NavGroup key={item.id} item={item} />
            ))}
        </List>
    );
};

export default MenuList;